import { render, staticRenderFns } from "./pdf4.vue?vue&type=template&id=2c739650&scoped=true"
import script from "./pdf4.vue?vue&type=script&lang=js"
export * from "./pdf4.vue?vue&type=script&lang=js"
import style0 from "./pdf4.vue?vue&type=style&index=0&id=2c739650&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c739650",
  null
  
)

export default component.exports